import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import EntityIndicatorDialog from '../EntityIndicatorDialog'
import { Divider, Grid } from '@mui/material'
import IndicatorHeaderDialog from '../IndicatorHeaderDialog'
import IndicatorTable from '../IndicatorTable'
import { shallowEqual, useSelector } from 'react-redux'
import { CHECKBOX, P103_2B, VP_077, VP_236, VP_237, VP_238, VP_239, VP_240, VP_241, VP_242, VP_243, VP_244, VP_245, VP_246, VP_247, VP_248, VP_249, VP_263, VP_264 } from 'rpqs/constants/RpqsConstant'
import { getIndicatorDialogRow, updateIndicatorEntity, updateManyIndicatorEntity } from 'rpqs/utils/RPQSUtils'
import { round, sum } from 'lodash'

const INDICATOR_CODES = [VP_077.code, VP_236.code, VP_237.code, VP_238.code, VP_239.code, VP_241.code, VP_242.code, VP_243.code, VP_244.code, VP_245.code, VP_246.code, VP_247.code, VP_248.code, VP_249.code]

const DialogP103_2B = ({
    open = false,
    setOpen = () => {},
    title = '',
}) => {
    const {
        rpqs,
        managementEntity,
    } = useSelector(store => ({
        rpqs: store.RpqsReducer.rpqs,
        managementEntity: store.CollectivityReducer.managementEntity,
    }), shallowEqual)

    const [entityDialog, setEntityDialog] = useState(managementEntity)

    useEffect(() => {
        setEntityDialog(managementEntity)
    }, [managementEntity])

    const year = rpqs.year
    const previousYear = year-1
    const currentEntity = entityDialog?.[year]

    const getIndicatorValue = (indicator) => (currentEntity?.[indicator]?.value || 0)

    const formatedIndicators = [
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_077.code,
            indicatorName: i18n[VP_077.i18n],
            unit: 'km',
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_236.code,
            indicatorName: i18n[VP_236.i18n],
            unit: `${i18n.nbPoint} / 0-10 ${i18n.points}`,
            onChange: v => setEntityDialog(prev => {
                return updateManyIndicatorEntity(prev, year, [
                    { code: VP_236.code, value: { ...currentEntity?.[VP_236.code], value: parseInt(v) || 0 } },
                    { code: VP_263.code, value: { ...currentEntity?.[VP_263.code], value: round((parseInt(v) + getIndicatorValue(VP_237.code)) * 100 / 15, 2) } },
                    { code: VP_264.code, value: { ...currentEntity?.[VP_264.code], value: round((parseInt(v) + getIndicatorValue(VP_237.code) + getIndicatorValue(VP_238.code) + getIndicatorValue(VP_239.code) + getIndicatorValue(VP_241.code)) * 100 / 45, 2) } },
                ])
            },
            ),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_237.code,
            indicatorName: i18n[VP_237.i18n],
            unit: `${i18n.nbPoint} / 0-5 ${i18n.points}`,
            onChange: v => setEntityDialog(prev => (updateManyIndicatorEntity(prev, year, [
                { code: VP_237.code, value: { ...currentEntity?.[VP_237.code], value: parseInt(v) || 0 } },
                { code: VP_263.code, value: { ...currentEntity?.[VP_263.code], value: round((parseInt(v) + getIndicatorValue(VP_236.code)) * 100 / 15, 2) } },
                { code: VP_264.code, value: { ...currentEntity?.[VP_264.code], value: round((parseInt(v) + getIndicatorValue(VP_236.code) + getIndicatorValue(VP_238.code) + getIndicatorValue(VP_239.code) + getIndicatorValue(VP_241.code)) * 100 / 45, 2) } },
            ]))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_238.code,
            indicatorName: i18n[VP_238.i18n],
            unit: `${i18n.nbPoint} / 0-10 ${i18n.points}`,
            onChange: v => setEntityDialog(prev => (updateManyIndicatorEntity(prev, year, [
                { code: VP_238.code, value: { ...currentEntity?.[VP_238.code], value: parseInt(v) || 0 } },
                { code: VP_264.code, value: { ...currentEntity?.[VP_264.code], value: round((parseInt(v) + getIndicatorValue(VP_236.code) + getIndicatorValue(VP_237.code) + getIndicatorValue(VP_239.code) + getIndicatorValue(VP_241.code)) * 100 / 45, 2) } },
            ]))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_239.code,
            indicatorName: i18n[VP_239.i18n],
            unit: `${i18n.nbPoint} / ${i18n.oneTofive} ${i18n.points}`,
            onChange: v => setEntityDialog(prev => (updateManyIndicatorEntity(prev, year, [
                { code: VP_239.code, value: { ...currentEntity?.[VP_239.code], value: parseInt(v) || 0 } },
                { code: VP_264.code, value: { ...currentEntity?.[VP_264.code], value: round((parseInt(v) + getIndicatorValue(VP_236.code) + getIndicatorValue(VP_237.code) + getIndicatorValue(VP_238.code) + getIndicatorValue(VP_241.code)) * 100 / 45, 2) } },
            ]))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_240.code,
            indicatorName: i18n[VP_240.i18n],
            unit: 'Condition de calcul',
            inputType: CHECKBOX,
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_240.code,
                { ...currentEntity?.[VP_240.code], value: v },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_241.code,
            indicatorName: i18n[VP_241.i18n],
            unit: `${i18n.nbPoint} / 0-15 ${i18n.points}`,
            onChange: v => setEntityDialog(prev => (updateManyIndicatorEntity(prev, year, [
                { code: VP_241.code, value: { ...currentEntity?.[VP_241.code], value: parseInt(v) || 0 } },
                { code: VP_264.code, value: { ...currentEntity?.[VP_264.code], value: round((parseInt(v) + getIndicatorValue(VP_236.code) + getIndicatorValue(VP_237.code) + getIndicatorValue(VP_238.code) + getIndicatorValue(VP_239.code)) * 100 / 45, 2) } },
            ]))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_242.code,
            indicatorName: i18n[VP_242.i18n],
            unit: `${i18n.nbPoint} / 0-10 ${i18n.points}`,
            onChange: v => setEntityDialog(prev => (updateManyIndicatorEntity(prev, year, [
                { code: VP_242.code, value: { ...currentEntity?.[VP_242.code], value: parseInt(v) || 0 } },
                { code: 'subtotalPartC', value: { ...currentEntity?.subtotalPartC, value: round((parseInt(v) + sum([VP_243.code, VP_244.code, VP_245.code, VP_246.code, VP_247.code, VP_248.code, VP_249.code].map(getIndicatorValue))) * 100 / 75, 2) } },
            ]))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_243.code,
            indicatorName: i18n[VP_243.i18n],
            unit: `${i18n.nbPoint} / 0-10 ${i18n.points}`,
            onChange: v => setEntityDialog(prev => (updateManyIndicatorEntity(prev, year, [
                { code: VP_243.code, value: { ...currentEntity?.[VP_243.code], value: parseInt(v) || 0 } },
                { code: 'subtotalPartC', value: { ...currentEntity?.subtotalPartC, value: round((parseInt(v) + sum([VP_242.code, VP_244.code, VP_245.code, VP_246.code, VP_247.code, VP_248.code, VP_249.code].map(getIndicatorValue))) * 100 / 75, 2) } },
            ]))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_244.code,
            indicatorName: i18n[VP_244.i18n],
            unit: `${i18n.nbPoint} / 0-10 ${i18n.points}`,
            onChange: v => setEntityDialog(prev => (updateManyIndicatorEntity(prev, year, [
                { code: VP_244.code, value: { ...currentEntity?.[VP_244.code], value: parseInt(v) || 0 } },
                { code: 'subtotalPartC', value: { ...currentEntity?.subtotalPartC, value: round((parseInt(v) + sum([VP_243.code, VP_242.code, VP_245.code, VP_246.code, VP_247.code, VP_248.code, VP_249.code].map(getIndicatorValue))) * 100 / 75, 2) } },
            ]))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_245.code,
            indicatorName: i18n[VP_245.i18n],
            unit: `${i18n.nbPoint} / 0-10 ${i18n.points}`,
            onChange: v => setEntityDialog(prev => (updateManyIndicatorEntity(prev, year, [
                { code: VP_245.code, value: { ...currentEntity?.[VP_245.code], value: parseInt(v) || 0 } },
                { code: 'subtotalPartC', value: { ...currentEntity?.subtotalPartC, value: round((parseInt(v) + sum([VP_243.code, VP_244.code, VP_242.code, VP_246.code, VP_247.code, VP_248.code, VP_249.code].map(getIndicatorValue))) * 100 / 75, 2) } },
            ]))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_246.code,
            indicatorName: i18n[VP_246.i18n],
            unit: `${i18n.nbPoint} / 0-10 ${i18n.points}`,
            onChange: v => setEntityDialog(prev => (updateManyIndicatorEntity(prev, year, [
                { code: VP_246.code, value: { ...currentEntity?.[VP_246.code], value: parseInt(v) || 0 } },
                { code: 'subtotalPartC', value: { ...currentEntity?.subtotalPartC, value: round((parseInt(v) + sum([VP_243.code, VP_244.code, VP_245.code, VP_242.code, VP_247.code, VP_248.code, VP_249.code].map(getIndicatorValue))) * 100 / 75, 2) } },
            ]))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_247.code,
            indicatorName: i18n[VP_247.i18n],
            unit: `${i18n.nbPoint} / 0-10 ${i18n.points}`,
            onChange: v => setEntityDialog(prev => (updateManyIndicatorEntity(prev, year, [
                { code: VP_247.code, value: { ...currentEntity?.[VP_247.code], value: parseInt(v) || 0 } },
                { code: 'subtotalPartC', value: { ...currentEntity?.subtotalPartC, value: round((parseInt(v) + sum([VP_243.code, VP_244.code, VP_245.code, VP_246.code, VP_242.code, VP_248.code, VP_249.code].map(getIndicatorValue))) * 100 / 75, 2) } },
            ]))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_248.code,
            indicatorName: i18n[VP_248.i18n],
            unit: `${i18n.nbPoint} / 0-10 ${i18n.points}`,
            onChange: v => setEntityDialog(prev => (updateManyIndicatorEntity(prev, year, [
                { code: VP_248.code, value: { ...currentEntity?.[VP_248.code], value: parseInt(v) || 0 } },
                { code: 'subtotalPartC', value: { ...currentEntity?.subtotalPartC, value: round((parseInt(v) + sum([VP_243.code, VP_244.code, VP_245.code, VP_246.code, VP_247.code, VP_242.code, VP_249.code].map(getIndicatorValue))) * 100 / 75, 2) } },
            ]))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_249.code,
            indicatorName: i18n[VP_249.i18n],
            unit: `${i18n.nbPoint} / 0-5 ${i18n.points}`,
            onChange: v => setEntityDialog(prev => (updateManyIndicatorEntity(prev, year, [
                { code: VP_249.code, value: { ...currentEntity?.[VP_249.code], value: parseInt(v) || 0 } },
                { code: 'subtotalPartC', value: { ...currentEntity?.subtotalPartC, value: round((parseInt(v) + sum([VP_243.code, VP_244.code, VP_245.code, VP_246.code, VP_247.code, VP_248.code, VP_242.code].map(getIndicatorValue))) * 100 / 75, 2) } },
            ]))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            readMode: true,
            codeIndicator: VP_263.code,
            indicatorName: i18n[VP_263.i18n],
            unit: '%',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_263.code,
                { ...currentEntity?.[VP_263.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            readMode: true,
            codeIndicator: VP_264.code,
            indicatorName: i18n[VP_264.i18n],
            unit: '%',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_264.code,
                { ...currentEntity?.[VP_264.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            readMode: true,
            keyLabel: 'subtotalPartC',
            indicatorName: i18n.subtotalPartC,
            unit: '%',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, 'subtotalPartC',
                { ...currentEntity?.subtotalPartC, value: parseInt(v) || 0 },
            ))),
        }),
    ]

    const onStatusChange = (status) => {
        setEntityDialog(updateIndicatorEntity(entityDialog, year, P103_2B.code, { ...currentEntity?.[P103_2B.code], status }))
    }

    const calculation = () => {
        const calculatedValue = sum(INDICATOR_CODES.map(getIndicatorValue))

        return updateIndicatorEntity(entityDialog, year, P103_2B.code, { ...currentEntity?.[P103_2B.code], value: calculatedValue })
    }

    return (
        <EntityIndicatorDialog
            open={open}
            setOpen={setOpen}
            title={title}
            hasNote
            entityDialog={entityDialog}
            setEntityDialog={setEntityDialog}
            codeIndicator={P103_2B.code}
            calculationOnRegister={calculation}
        >
            <Grid container direction={'column'} gap={2}>
                <IndicatorHeaderDialog
                    current={{
                        year,
                        value: managementEntity?.[year]?.[P103_2B.code]?.value,
                    }}
                    previous={{
                        year: previousYear,
                        value: managementEntity?.[previousYear]?.[P103_2B.code]?.value,
                    }}
                    status={entityDialog?.[year]?.[P103_2B.code]?.status}
                    onStatusChange={onStatusChange}
                    unit={i18n.points}
                />
                <Divider/>
                <IndicatorTable
                    year={year?.toString()}
                    indicators={formatedIndicators}
                />

            </Grid>
        </EntityIndicatorDialog>
    )
}

DialogP103_2B.propTypes = {
    setOpen: PropTypes.func,
    open: PropTypes.bool,
    title: PropTypes.string,
}

export default DialogP103_2B
